import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    plansSelector,
    subscribingSelector,
    userPaymentMethodsSelector,
    userSubscriptionSelector,
} from '../EsSettings/selector';
import { AccountSubscriptions as AccountSubscriptionsComponent } from '../../components/AccountSettings';
import { getSubscriptionPlans, setSubscription, subscribe } from '../../redux/subscription/actions';
import { getPaymentMethods, getPublishableKey } from '../../redux/payment/action';
import { IChangePayload } from '../../redux/subscription/types';
import { ISettingsProps } from '../../components/AccountSettings/AccountSubscriptions';
import { showToastMessage } from '../../utils/AppUtils';

interface IAccountSubscription extends ISettingsProps {
    onDone?: VoidFunction;
}
const AccountSubscriptions: React.FC<IAccountSubscription> = ({ onDone, isPromptMode }) => {
    const plans = useSelector(plansSelector);
    const paymentMethods = useSelector(userPaymentMethodsSelector);
    const subscription = useSelector(userSubscriptionSelector);
    const loading = useSelector(subscribingSelector);

    const dispatch = useDispatch();
    const handleSubscribe = (payload: IChangePayload) => {
        if (payload.paymentMethodId) {
            dispatch(subscribe(payload));
            onDone && onDone();
        } else {
            showToastMessage('Missing params', 'info');
        }
    };

    const getSubscriptions = useCallback(() => {
        dispatch(getSubscriptionPlans());
        dispatch(getPublishableKey({ source: 'stripe' }));
        dispatch(getPaymentMethods());
        dispatch(setSubscription());
    }, [dispatch]);

    useEffect(() => {
        getSubscriptions();
    }, [getSubscriptions]);

    return (
        <AccountSubscriptionsComponent
            onChange={payload => handleSubscribe(payload)}
            plans={plans}
            userCards={paymentMethods}
            initialPlan={subscription}
            isPromptMode={isPromptMode}
            loading={loading}
        />
    );
};

export { AccountSubscriptions };
